<nav mat-tab-nav-bar style="margin-top: 63px; width: 100%; padding: 0">
    <a
        #ot="routerLinkActive"
        *ngIf="isTabMenuVisible('/support/tickets')"
        [active]="ot.isActive"
        [routerLink]="['/support/tickets']"
        mat-tab-link
        routerLinkActive
        >Tickets</a
    >
    <a
        #th="routerLinkActive"
        *ngIf="isTabMenuVisible('/support/ticket-historie')"
        [active]="th.isActive"
        [routerLink]="['/support/ticket-historie']"
        mat-tab-link
        routerLinkActive
        >Ticket-Historie</a
    >
</nav>
<router-outlet></router-outlet>
